module.exports = __webpack_public_path__ + "img/why-us-2.682801f9.webp";